<template>
  <easy-page-template
      title="契約をどのように作成しますか？"
      subtitle="取引契約を作成する方法を、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconTradeContractTradeContractPropose"
          title="自事業者のデータから発行"
          to="/profileManagement/dataProfiles"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconTradeContractTradeContractResponse"
          title="取引先のデータから発行"
          to="/profileSearch/dataProfiles"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import imageTradeContract from "./assets/image_trade_contract.svg";
import iconTradeContractTradeContractPropose from "./assets/icon_trade_contract_trade_contract_propose.svg";
import iconTradeContractTradeContractResponse from "./assets/icon_trade_contract_trade_contract_response.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "TradeContract",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconTradeContractTradeContractPropose,
      iconTradeContractTradeContractResponse,
      imageTradeContract
    }
  }
}
</script>

<style scoped>

</style>
